import { createSelector } from 'reselect';

import { GlobalState } from 'store/types';

import { KEY, SalesErrorState } from './types';

const getSalesErrorsState = (state: GlobalState) => state[KEY] as SalesErrorState;

const selectError = createSelector(
  getSalesErrorsState,
  state => state.error
);

const selectAdditionalInfo = createSelector(
  getSalesErrorsState,
  state => state.additionalInfo
);

const selectErrorType = createSelector(
  getSalesErrorsState,
  state => state.type
);

export const selectors = {
  selectError,
  selectAdditionalInfo,
  selectErrorType
};
